import MomentUtils from '@date-io/moment';
import _ from 'lodash';
import { Button, TextField, Checkbox } from "@material-ui/core";
import { createStyles, withStyles, WithStyles } from '@material-ui/core/styles';
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import moment from 'moment';
import * as React from "react";
import Select from 'react-select';
import { IWalletPlantOutDTO } from '../../repository/jago/model/output/IWalletPlantOutDTO';
import ReduxLanguage from "../ReduxLanguage";
import translations from '../../translations/i18next';
import { ISegmentTypeEnum } from '../../repository/jago/model/output/ISegmentTypeEnum';
import { DomainIrisStatusOptions } from '../../repository/jago/model/input/IDomainInDTO';
import AbilityProvider from '../../services/PermissionService/AbilityProvider';
import { Roles } from '../../services/PermissionService/PermissionConstants';
import { isSegmentTypeDeprecated } from '../../utils/Utils';

/** Max length of a DNS label (subdomain) before `.jago.cloud`. */
const walletPlantDomainLabelMaxLength = 50;

function isValidWalletPlantDomainLabel(text: string): boolean {
  if (!text || text.length > walletPlantDomainLabelMaxLength) {
    return false;
  }
  return /^[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?$/.test(text);
}

const styles = createStyles({
  container: {
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: 'white',
    padding: 20,
    height: '100%',
    flex: 1,
  },
  formTitle: {
    marginBottom: 20,
  },
  errorText: {
    color: 'red'
  },
  inputTitle: {
    marginTop: 20,
    marginBottom: 8,
    fontSize: 18,
    fontWeight: 'bold',
  },
  disabledButton: {
    backgroundColor: 'red'
  },
  inputTitleContainer: {
    display: 'flex',
    alignItems: 'center',
  },
  italicText: {
    fontStyle: 'italic',
  },
  checkboxContainer: {
    display: 'flex',
    flexDirection: 'row',
    marginTop: 20,
    alignItems: 'center',
  }
});

export interface IWalletRechargeFormState {
  plantData: IWalletPlantOutDTO;
  textInputErrors: { [key: string]: boolean; };
  irisCheckboxState: boolean;
  initialSegmentType?: string;
};

export interface IWalletPlantFormProps extends WithStyles<typeof styles>{
  onSaveWalletPlatData: (plant: IWalletPlantOutDTO) => void;
  walletId: number;
}

class WalletPlantForm extends React.Component<IWalletPlantFormProps, IWalletRechargeFormState> {

  constructor(props: IWalletPlantFormProps) {
    super(props);
    this.state = {
      initialSegmentType: undefined, // props.plantData ? props.plantData.segmentType : undefined,
      plantData: {
        name: '',
        emailEnabled: true,
        walletId: props.walletId,
        enable1ris: DomainIrisStatusOptions.NOT_REQUIRED,
        solution: 'LUCKEY',
        management: 'SAAS',
      },
      textInputErrors: {
        name: false,
        emailEnabled: false,
      },
      irisCheckboxState: false,
    };
  }

  public onChangeDomainNameText(text:string) {
    const { plantData } = this.state;
    if (isValidWalletPlantDomainLabel(text)) {
      this.setErrorForField('name', false);
    } else {
      this.setErrorForField('name', true);
    }
    (plantData as any)['name'] = text;
      this.setState({ plantData });
  }
  
  public onSetValue(field: keyof IWalletPlantOutDTO, value: any) {
    const { plantData } = this.state;
    if (!value) {
      this.setErrorForField(field, true);
    } else {
      this.setErrorForField(field, false);
    }
    if (value && value < 0) {
      this.setErrorForField(field, true);
    }
    (plantData as any)[field] = value;
    this.setState({ plantData });
  }

  public onSetIrisCheckbox(value: boolean) {
    const { plantData } = this.state;
    (plantData as any)['enable1ris'] = value?DomainIrisStatusOptions.REQUIRED:DomainIrisStatusOptions.NOT_REQUIRED;
    this.setState({ irisCheckboxState: value });
  }  

  public setErrorForField(field: string, hasError: boolean) {
    const { textInputErrors } = this.state;
    textInputErrors[field] = hasError;
    this.setState({ textInputErrors });
  }

  public canSubmitForm() {
    const { plantData, textInputErrors } = this.state;
    if (!plantData.name || plantData.emailEnabled === undefined || !plantData.segmentType) {
      return false;
    }
    if (textInputErrors.name || !isValidWalletPlantDomainLabel(plantData.name)) {
      return false;
    }
    return true;
  }
    

  public onSubmitForm() {
    const { plantData } = this.state;
    const { onSaveWalletPlatData } = this.props;
    if (this.canSubmitForm()) {
      onSaveWalletPlatData(plantData);
    }
  }

  public render() {
    const { classes } = this.props;
    const { plantData, initialSegmentType, textInputErrors, irisCheckboxState } = this.state;

    const segmentTypeOptions = _.map(ISegmentTypeEnum, (v) => ({ value: v }))

    return (
      <MuiPickersUtilsProvider utils={MomentUtils} locale={moment.locale()}>
        <div className={classes.container}>
          <h4 style={{ marginTop: 0, marginLeft: 0, marginBottom: 3, fontWeight: 'bold' }}>{<ReduxLanguage languageKey={'forms.domainName'} />}<span style={{ color: 'red' }}>*</span></h4>
          <TextField
            id="outlined-basic"
            variant="outlined"
            fullWidth
            required
            style={{ marginTop: 10 }}
            error={textInputErrors.name}
            value={plantData?.name}
            onChange={e => this.onChangeDomainNameText(e.target.value)}
          />
          {textInputErrors && textInputErrors.name ? <h4 className={classes.errorText}>{`${translations.t('forms.invalidDomainName')}`}</h4> : null}
          {plantData && plantData.name.length ? <h4 style={{ fontWeight: 'bold' }}>{`${translations.t('forms.domainNamePreview')}: https://${plantData.name}.jago.cloud`}</h4> : null}
          
          <h4 style={{ marginTop: 20, marginLeft: 0, marginBottom: 3, fontWeight: 'bold' }}>{<ReduxLanguage languageKey={'forms.selectSegmentType'} />}<span style={{ color: 'red' }}>*</span></h4>
          <Select
            value={segmentTypeOptions.filter(e=>e.value===plantData.segmentType).length?segmentTypeOptions.filter(e=>e.value===plantData.segmentType)[0]:null}
            options={segmentTypeOptions}
            isClearable
            required
            placeholder={<ReduxLanguage languageKey={'forms.selectSegmentType'} />}
            onChange={(e) => this.onSetValue('segmentType', e?.value)}
            formatOptionLabel={(v) => v.value ? (
              isSegmentTypeDeprecated(v.value) ? (
                <>
                  <b style={{ color: '#999' }}>{`${translations.t('segmentTypes.'+v.value+"_name")}`}</b> 
                  <span style={{ color: '#999' }}>{translations.t('segmentTypes.'+v.value+"_description")!==('segmentTypes.'+v.value+"_description") ? ` [${translations.t('segmentTypes.'+v.value+"_description")}]` : ""}</span>
                  <span style={{ color: '#999', fontStyle: 'italic', marginLeft: 2 }}>({translations.t('segmentTypes.deprecated')})</span>
                </>
              ) : (
                <>
                  <span style={{ }}>{translations.t('segmentTypes.'+v.value+"_name")}</span>
                </>
              )
            ):""}
            isOptionDisabled={(option) => isSegmentTypeDeprecated(option.value) && option.value !== initialSegmentType}
            styles={{
              menu: (styles) => Object.assign(styles, { zIndex: 1000 }),
              control: (styles) => ({ ...styles, minHeight: 55 }),
              option: (styles, { isDisabled }) => ({
                ...styles,
                color: isDisabled ? '#999' : styles.color,
                backgroundColor: isDisabled ? '#f5f5f5' : styles.backgroundColor,
                cursor: isDisabled ? 'not-allowed' : styles.cursor,
              }),
            }}
          />
          <div className={classes.checkboxContainer}>
            <Checkbox
              checked={plantData?.emailEnabled}
              onChange={(e, checked) => this.onSetValue('emailEnabled', checked)}
              inputProps={{ 'aria-label': 'primary checkbox' }}
            />
            <div>
              <h4 style={{ fontWeight: 'bold' }}>{<ReduxLanguage languageKey={'forms.enableEmailForPlant'} />}</h4>
              <h5>{<ReduxLanguage languageKey={'forms.enableEmailForPlantDescription'} />}</h5>
            </div>
          </div>
          
          <div className={classes.checkboxContainer}>
            <Checkbox
              checked={irisCheckboxState}
              onChange={(e, checked) => this.onSetIrisCheckbox(checked)}
              inputProps={{ 'aria-label': 'primary checkbox' }}
            />
            <div>
              <h4 style={{ fontWeight: 'bold' }}>{<ReduxLanguage languageKey={'forms.enableIrisRequiredForPlant'} />}</h4>
              <h5>{<ReduxLanguage languageKey={'forms.enableIrisRequiredForPlantDescription'} />}</h5>
            </div>
          </div>
          
          <Button
            variant="contained"
            disabled={!this.canSubmitForm()}
            style={{ width: '100%', opacity: this.canSubmitForm() ? 1 : 0.5, backgroundColor: '#5AC0B1', color: 'white', marginTop: 20, fontWeight: 'bold'  }}
            onClick={() => this.onSubmitForm()}
          >
            <ReduxLanguage languageKey="forms.save" />
          </Button>
        </div>
      </MuiPickersUtilsProvider>
    );
  }
}

export default withStyles(styles)(WalletPlantForm);